import { render, staticRenderFns } from "./PlanMg.vue?vue&type=template&id=5e6c7922&scoped=true&lang=pug&"
var script = {}
import style0 from "./PlanMg.vue?vue&type=style&index=0&id=5e6c7922&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6c7922",
  null
  
)

export default component.exports